import { createContext, type ReactNode, useContext } from 'react';

/**
 * Whether the surrounding tab is the one currently shown.
 *
 * Defaults to `true` so any query rendered outside a keep-alive tab host
 * (single-tab pages, reports, the shared-report viewer) behaves exactly as
 * before. `KeepAliveTabGrids` keeps every visited tab mounted and sets this to
 * `false` for the hidden ones, which lets their queries pause instead of
 * refetching in the background when a shared filter changes.
 */
const TabVisibilityContext = createContext<boolean>(true);

export const TabVisibilityProvider = ({
  isVisible,
  children,
}: {
  isVisible: boolean;
  children: ReactNode;
}) => (
  <TabVisibilityContext.Provider value={isVisible}>
    {children}
  </TabVisibilityContext.Provider>
);

export const useIsTabVisible = () => useContext(TabVisibilityContext);
